class VouchersService {
  static base = '';

  static validateCard = `${this.base}/gift-cards/validate`;
}

export default VouchersService;
